import { FaArrowDownLong } from "react-icons/fa6";
import AppSelect from "../../../components/AppSelect";
import { useState } from "react";
import { Button } from "../../../layout/component/Button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  dateFormatter,
  dateFormatter2,
  dateFormatter3,
} from "../../../utils/functions";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Travellers from "./Dropdown";
import { useAppDispatch } from "../../../store";
import toast from "react-hot-toast";
import { PuffLoader } from "react-spinners";
import { routeObj } from "../../../constants/routes";
import { setSearchParams, setOtherParams } from "../../../store/slice/update";
import { airports, nigerianStatesAndAirports } from "../../../utils/data";

export default function Search() {
  const [selectedTags, setSelectedTags] = useState<any>();
  const [selectedFro, setSelectedFro] = useState<any>();
  const [start_date, setStartDate] = useState<string | Date>(new Date());
  const [end_date, setEndDate] = useState<Date | undefined>(undefined);
  const [isFrom, setIsFrom] = useState(false);
  const [isTo, setIsTo] = useState(false);
  const [trip, setTrip] = useState<"ROUND_TRIP" | "ONE_WAY">("ROUND_TRIP");
  const [children, setChildren] = useState<number>(0);
  const [adults, setAdult] = useState<number>(1);
  const router = useNavigate();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const findIATACode = (val: string) => {
    const airport = nigerianStatesAndAirports.find(
      (state) => state.state === val
    );
    return airport?.code;
  };

  return (
    <div className="md:bg-white relative w-[90%] min-h-[70px] flex-wra p-3 pb-5 flex flex-col  gap-5  md:gap-3  md:rounded-full my-6 ">
      <div className=" md:text-black gap-6 text-sm flex justify-center items-center w-full ">
        <label
          className=" cursor-pointer "
          onChange={() => setTrip("ONE_WAY")}
          htmlFor="ONE_WAY"
        >
          <input
            type="radio"
            checked={trip === "ONE_WAY"}
            name="trip_type"
            id="ONE_WAY"
            className="accent-black"
            value={"ONE_WAY"}
            readOnly
          />{" "}
          One Way
        </label>
        <label
          className=" cursor-pointer "
          onChange={() => setTrip("ROUND_TRIP")}
          htmlFor="ROUND_TRIP"
        >
          <input
            type="radio"
            checked={trip === "ROUND_TRIP"}
            name="trip_type"
            id="ROUND_TRIP"
            value={"ROUND_TRIP"}
            className="accent-black"
            readOnly
          />{" "}
          Round Trip
        </label>
      </div>
      <div className=" flex flex-col md:flex-row  w-full justify-center items-center gap-5  md:gap-3 ">
        <div
          onClick={() => {
            setIsFrom(!isFrom);
            setIsTo(false);
          }}
          className={`h-full w-full  ${
            trip === "ROUND_TRIP" ? "md:w-[20%]" : "md:w-[25%]"
          } relative rounded-lg cursor-pointer md:rounded-none bg-white md:bg-transparent p-3 md:p-0 md:border-r-[1px]  `}
        >
          <div className=" w-full h-full flex items-center justify-between bg-green-00 ">
            <div className=" flex gap-2 items-center ">
              <div className=" rounded-full p-1 bg-main/10   ">
                <img width={40} src="/img/flight.png" alt="" />
              </div>
              <div className=" text-sm font-bold text-black ">
                <p className="">From</p>
                <p className="">
                  {selectedTags ? selectedTags?.value : "Flying From?"}
                </p>
              </div>
            </div>
            {
              <Button
                onClick={() => {
                  setIsFrom(!isFrom);
                  setIsTo(false);
                }}
                // ${!selectedTags ? "animate-bounce" : ""}
                className={` mr-3 rounded-full p bg-main/5 `}
              >
                <FaArrowDownLong fill="black" />
              </Button>
            }
          </div>
          {isFrom && (
            <div
              onClick={(e) => e.stopPropagation()}
              className="  w-full h-full bg-red-00 top-[64px] absolute "
            >
              <AppSelect
                selected={selectedTags}
                setSelected={setSelectedTags}
                label="Search Destination"
                options={airports}
                variant="rounded"
                className="rounded-lg"
                onChange={() => {
                  setIsFrom(false);
                }}
              />
            </div>
          )}
        </div>
        <div
          onClick={() => {
            setIsTo(!isTo);
            setIsFrom(false);
          }}
          className={`h-full w-full cursor-pointer  ${
            trip === "ROUND_TRIP" ? "md:w-[20%]" : "md:w-[25%]"
          } relative rounded-lg md:rounded-none bg-white md:bg-transparent p-3 md:p-0 md:border-r-[1px]  `}
        >
          <div className=" w-full h-full flex items-center justify-between bg-green-00 ">
            <div className=" flex gap-2 items-center ">
              <div className=" rounded-full p-1 bg-main/10   ">
                <img width={40} src="/img/flight_l.png" alt="" />
              </div>
              <div className=" text-sm font-bold text-black ">
                <p className="">To</p>
                <p className="">
                  {selectedFro ? selectedFro?.value : "En route to?"}
                </p>
              </div>
            </div>
            {
              <Button
                onClick={() => {
                  setIsTo(!isTo);
                  setIsFrom(false);
                }}
                className={`rounded-full p bg-main/5  mr-3`}
              >
                <FaArrowDownLong fill="black" />
              </Button>
            }
          </div>
          {isTo && (
            <div
              onClick={(e) => e.stopPropagation()}
              className=" w-full h-full bg-red-00 top-[64px] absolute "
            >
              <AppSelect
                selected={selectedFro}
                setSelected={setSelectedFro}
                label="select where to...."
                options={airports}
                variant="rounded"
                className="rounded-lg"
                onChange={() => {
                  setIsTo(false);
                }}
              />
            </div>
          )}
        </div>
        <div
          className={`h-full w-full  ${
            trip === "ROUND_TRIP" ? "md:w-[20%]" : "md:w-[25%]"
          } relative rounded-lg md:rounded-none bg-white md:bg-transparent p-3 md:p-0 md:border-r-[1px]  `}
        >
          <div className=" w-full h-full flex items-center justify-between bg-green-00 ">
            <div className=" flex gap-2 items-center ">
              <div className=" text-sm font-bold text-black ">
                <p className=" text-[13px] ">Depature</p>
                <p className="">
                  {dateFormatter(
                    start_date
                      ? (start_date as string)
                      : new Date().toISOString()
                  )}
                </p>
              </div>
            </div>
            {
              <div
                className={` bg-green-00 h-5 w-10 -top-5 flex  items-center justify-center  relative    mr-3`}
              >
                <DatePicker
                  onChange={(date) => {
                    setStartDate(date?.toISOString()!);
                  }}
                  minDate={new Date()}
                  showIcon
                  popperPlacement="top-start"
                  toggleCalendarOnIconClick
                  className=" w-[100%] absolute outline-none disabled:cursor-not-allowed"
                />
              </div>
            }
          </div>
        </div>
        {trip === "ROUND_TRIP" && (
          <div
            className={`h-full w-full cursor-pointer  ${
              trip === "ROUND_TRIP" ? "md:w-[20%]" : "md:w-[25%]"
            } relative rounded-lg md:rounded-none bg-white md:bg-transparent p-3 md:p-0 md:border-r-[1px]  `}
          >
            <div className=" w-full h-full flex items-center justify-between bg-green-00 ">
              <div className=" flex gap-2 items-center ">
                <div className=" text-sm font-bold text-black ">
                  <p className="text-[13px]">Return</p>
                  <p className="">
                    {end_date
                      ? dateFormatter(end_date.toISOString())
                      : "+ Add Return Date"}
                  </p>
                </div>
              </div>
              {
                <div
                  className={` bg-green-00 h-5 w-10 -top-5 flex  items-center justify-center  relative    mr-3`}
                >
                  <DatePicker
                    selected={new Date(start_date)}
                    startDate={new Date(start_date)}
                    endDate={end_date}
                    selectsRange
                    popperPlacement="top-start"
                    onChange={(date) => {
                      const [start, end] = date;
                      setStartDate(start!);
                      setEndDate(end!);
                    }}
                    minDate={new Date(start_date)}
                    showIcon
                    toggleCalendarOnIconClick
                    className=" w-[100%] absolute outline-none disabled:cursor-not-allowed"
                  />
                </div>
              }
            </div>
          </div>
        )}
        <div className=" h-full w-full  md:w-[15%] relative rounded-lg md:rounded-none bg-white md:bg-transparent p-3 md:p-0  ">
          <div className=" w-full h-full flex items-center justify-between bg-green-00 ">
            <div className=" flex gap-2 items-center ">
              <div className=" text-sm font-bold text-black ">
                <div className="text-[13px]">
                  <Travellers
                    adults={adults}
                    children={children}
                    setAdults={setAdult}
                    setChildren={setChildren}
                  />{" "}
                  ({adults + children})
                </div>
              </div>
            </div>
            <button
              onClick={async () => {
                try {
                  if (selectedTags && selectedFro && start_date) {
                    if (trip === "ROUND_TRIP" && !end_date) {
                      return toast.error("Please select return date");
                    }
                    setLoading(true);
                    dispatch(
                      setSearchParams({
                        arrival_id: findIATACode(selectedFro.value)!,
                        departure_id: findIATACode(selectedTags.value)!,
                        outbound_date: dateFormatter3(start_date as string),
                        return_date: dateFormatter3(end_date?.toISOString()!),
                      })
                    );
                    dispatch(
                      setOtherParams({
                        trip,
                        adults,
                        children,
                      })
                    );
                    setTimeout(() => {
                      setLoading(false);
                      router(routeObj.flight);
                    }, 2000);
                  } else {
                    toast.error("Search query is invalid");
                  }
                } catch (error: any) {
                  setLoading(false);
                  toast.error(error);
                }
              }}
              className={`  bg-main h-full p-4  rounded-[300px]    `}
            >
              {loading ? (
                <PuffLoader size={15} color="white" />
              ) : (
                <FaSearch fill="white" />
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
